export async function oldmap(id: number) {
  return http.get<{
    data: {
      resource_id: number
      resource_type: number
    }
  }>('/v1/mapping/old_id', { id })
}
